<template>
  <b-modal
    id="modal-schedule-fleet-task"
    class="schedule-fleet-task__modal"
    :title="$t('delivery.action.saveAndSchedule') + ' ' + $t('delivery.fields.fleetTask')"
    size="md"
    centered
    scrollable
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    @shown="() => { this.isLoading = false }"
  >
    <div class="card-body p-2">
      <McAlert
        class="mb-2"
        variant="warning"
        :html="$t('delivery.message.deliveryCannotEditOrDeleteAfterAction')"
        withIcon
        :withGap="false"
      />
    </div>
    <div class="card-body p-2">
      <p class="schedule-fleet-task__text" v-html="scheduledStatusFleetTaskCreatedMessage"></p>
    </div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0">
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('global.action.cancel')"
          :disabled="isLoading"
          @click="cancel()"
        />
        <McButton
          variant="primary"
          :text="$t('delivery.action.saveAndSchedule')"
          :disabled="isLoading"
          @click="handleSubmit"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import McAlert from '@/components/McAlert'
import { mapGetters } from 'vuex'

export default {
  components: {
    McButton,
    McAlert,
  },
  props: {
    parseData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  computed: {
    scheduledStatusFleetTaskCreatedMessage() {
      return this.$t('delivery.message.confirmSaveAndCreateAssignment', {
        count: `<strong>${this.parseData?.delivery_orders.length}</strong>`,
      })
    },
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),
  },
  methods: {
    async handleSubmit() {
      this.isLoading = true
      this.$emit('handleSubmit')
    },
  },
}
</script>
